/** Cmd/Ctrl+, opens Preferences from anywhere, including inside text fields, matching the desktop convention for a settings shortcut. */
import { useEffect } from 'react';

export function usePreferencesShortcut(enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== ',' || event.isComposing) return;
      if (!(event.metaKey || event.ctrlKey) || event.altKey || event.shiftKey) return;
      // The browser binds Cmd+, to its own settings on macOS.
      event.preventDefault();
      window.dispatchEvent(new CustomEvent('app:navigate', { detail: { view: 'preferences' } }));
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [enabled]);
}
